import PropTypes from 'prop-types';
import React, {useState, useEffect, useMemo} from 'react';
import {Helmet} from 'react-helmet';
import {Chip, Grid, Paper, Toolbar, Typography} from '@material-ui/core';
import {debounce} from 'throttle-debounce';
import {convertToObjectByKey} from '@ozgene/gp5.utils.array-functions';
import CnsProcedureList from 'CnsProcedureLobby/components/CnsProcedureList';
import CnsProcedureProperties from 'CnsProcedureLobby/components/CnsProcedureProperties';
import Loader from 'util/Loader';
import {findCnsProcedures} from 'Projects/service/ProjectService';

export default function CnsProcedureLobbyView(props, context) {
  const {
    location: {
      query: {procedureFilterText = ''},
    },
  } = props;
  const {router} = context;
  const decodedProcedureFilterText = decodeURIComponent(procedureFilterText);
  const [isLoading, setIsLoading] = useState(true);
  const [cnsProcedures, setCnsProcedures] = useState([]);
  const [selectedProcedureId, setSelectedProcedureId] = useState();
  const proceduresById = useMemo(() => convertToObjectByKey(cnsProcedures, 'id'), [cnsProcedures]);
  const selectedCnsProcedure = useMemo(
    () => proceduresById[selectedProcedureId],
    [selectedProcedureId, proceduresById],
  );
  const handleSelectionChange = (selection) => {
    if (!!selection && selection.length > 0) {
      setSelectedProcedureId(selection[selection.length - 1]);
    } else {
      setSelectedProcedureId();
    }
  };
  const handleChangeProcedureFilterText = debounce(1000, (filterText) => {
    const {
      location: {pathname, query: oldQuery},
    } = props;
    const query = {...oldQuery};

    if (!!filterText) {
      query.procedureFilterText = encodeURIComponent(filterText);
    } else {
      delete query.procedureFilterText;
    }

    router.replace({pathname, query});
  });

  useEffect(() => {
    const handleRetrieveProcedures = async () => {
      setCnsProcedures(await findCnsProcedures());
      setIsLoading(false);
    };

    if (isLoading && cnsProcedures.length === 0) {
      handleRetrieveProcedures();
    }
  }, [cnsProcedures.length, isLoading]);

  return (
    <>
      <Helmet title="Import Procedures" defer={false} />
      <Grid container spacing={2}>
        <Grid item xs={8} md={9}>
          <Paper>
            <Toolbar>
              <Typography style={{color: 'grey'}} variant="h5">
                Import Procedures
              </Typography>
              <Chip style={{marginLeft: 30}} variant="outlined" label={cnsProcedures.length} />
            </Toolbar>
            {isLoading ? (
              <Loader label="Loading Procedures..." />
            ) : (
              <CnsProcedureList
                cnsProcedures={cnsProcedures}
                onSelectionChange={handleSelectionChange}
                procedureFilterText={decodedProcedureFilterText}
                onChangeProcedureFilterText={handleChangeProcedureFilterText}
                selectedId={selectedProcedureId}
              />
            )}
          </Paper>
        </Grid>
        {!isLoading && (
          <Grid item xs={4} md={3}>
            <CnsProcedureProperties selectedCnsProcedure={selectedCnsProcedure} />
          </Grid>
        )}
      </Grid>
    </>
  );
}

CnsProcedureLobbyView.propTypes = {
  location: PropTypes.object.isRequired,
  params: PropTypes.object,
};

CnsProcedureLobbyView.contextTypes = {
  router: PropTypes.object.isRequired,
};

CnsProcedureLobbyView.defaultProps = {
  params: null,
};
